import { getDefaultPrintAreaForView } from '@/model/productType/getDefaultPrintAreaForView';
import { StoreState } from '@/redux/types';
import { getConfigurationsOnCurrentView } from './getConfigurationsOnCurrentView';
import { getCurrentView } from './getCurrentView';
import { getProductType } from './getProductType';

export function getPrintAreaForNewConfiguration(state: StoreState) {
  // returns a possibly deprecated print area if it already contains configurations
  // this is necessary to support editing old products
  const otherConfigurationsOnView = getConfigurationsOnCurrentView(state);
  if (otherConfigurationsOnView.length) {
    return otherConfigurationsOnView[0].printArea;
  }

  return getDefaultPrintAreaForView(getProductType(state), getCurrentView(state));
}
